import { defineMessages } from 'react-intl'

export default defineMessages({
  userAccessHeader: {
    id: 'purchasing.assignUsersToDepartment.view.userAccessHeader',
    defaultMessage: 'User access',
  },
  selectAll: {
    id: 'purchasing.assignUsersToDepartment.view.selectAll',
    defaultMessage: 'Select all',
  },
  deselectAll: {
    id: 'purchasing.assignUsersToDepartment.view.deselectAll',
    defaultMessage: 'Deselect all',
  },
  save: {
    id: 'purchasing.assignUsersToDepartment.view.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'purchasing.assignUsersToDepartment.view.cancel',
    defaultMessage: 'Cancel',
  },
  emptyState: {
    id: 'purchasing.assignUsersToDepartment.view.emptyState',
    defaultMessage: 'No users available.',
  },
})
